<div class="parent">
    <canvas #phoneCanvas class="phone-container gs_reveal"></canvas>
    <video #phoneVideo id="task-manager-vid" autoplay loop [muted]="'muted'" style="position:absolute; top:0; visibility:hidden">
        <source src="/assets/img/task-manager-vid.mp4" type="video/mp4">
    </video>
</div>
